import { newE2EPage } from '@stencil/core/testing';

describe('jackery-dropdown', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-dropdown></jackery-dropdown>');

    const element = await page.find('jackery-dropdown');
    expect(element).toHaveClass('hydrated');
  });
});
